import * as React from 'react';
import styled from 'styled-components';
import { Node } from 'slate';
import cl from 'classnames';
import { noop } from 'lodash';
import { IconReadOnlyPlugin } from '../../../../../DolEditor/elements/icons/IconPlugin';
import { onContentItemClick } from '../utils';
import { ContentItemProps } from '../TableOfContentType';
import { RendererWithPlugins } from '../../../../../../slatePlugins/components/core/readonly/RendererWithPlugins';
import { ResponsiveTypography } from '../../../../../Typography/v3/ResponsiveTypography';
import { deviceBreakpoints } from '../../../../../../hooks/useDeviceQuery.hook';

/* stylelint-disable no-descending-specificity */
const SubItemLayout = styled.ol`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 4px;
  padding-inline-start: 0;

  @media screen and ${deviceBreakpoints.fromDesktop} {
    gap: 8px;
  }
`;
const ItemWithSubItemWrapper = styled.li`
  list-style-type: none;

  ${SubItemLayout} {
    display: none;
    margin-top: 8px;
    padding-left: 20px;
  }

  &.sub-active {
    ${SubItemLayout} {
      display: grid;
    }
  }
`;

const plugins = [IconReadOnlyPlugin()];

export const ContentItemGroupWithEditor = (props: ContentItemProps) => {
  const { currentSectionId, scrollContainerElm, onClick = noop, ...item } = props;

  const active = React.useMemo(() => item.id === currentSectionId, [currentSectionId, item.id]);

  const subActive = React.useMemo(
    () => item.sub?.some((it) => it.id === currentSectionId),
    [currentSectionId, item.sub]
  );

  const editorContent = React.useMemo(() => {
    const { item: data } = item as any;
    return [data];
  }, [item]);

  const itemText = React.useMemo(() => {
    const { item: data } = item as any;
    return [data].map((n) => Node.string(n)).join('   ');
  }, [item]);

  const handleOnClick = () => {
    onContentItemClick(item.id, scrollContainerElm);
    onClick?.();
  };

  if (item?.sub?.length) {
    return (
      <ItemWithSubItemWrapper className={cl({ 'sub-active': subActive, active })}>
        <ResponsiveTypography.Text
          as="a"
          href={`#${item.id}`}
          ellipsis={{ tooltip: itemText }}
          className={cl({ active })}
          onClick={handleOnClick}
        >
          <RendererWithPlugins plugins={plugins} value={editorContent} />
        </ResponsiveTypography.Text>
        <SubItemLayout>
          {item.sub.map((child, idx) => (
            <ContentItemGroupWithEditor
              key={idx}
              currentSectionId={currentSectionId}
              scrollContainerElm={scrollContainerElm}
              {...child}
            />
          ))}
        </SubItemLayout>
      </ItemWithSubItemWrapper>
    );
  }
  return (
    <ResponsiveTypography.Text
      as="li"
      ellipsis={{ tooltip: itemText }}
      className={cl({ active })}
      onClick={handleOnClick}
    >
      <a href={`#${item.id}`}>
        <RendererWithPlugins plugins={plugins} value={editorContent} />
      </a>
    </ResponsiveTypography.Text>
  );
};
